<div class="h-full w-full relative">
  <div class="map" tabindex="0" #map></div>
</div>
